import { useEffect, useState } from "react";

const KEY = "ff-splash-seen";

export const SplashScreen = () => {
  const [phase, setPhase] = useState(() => (sessionStorage.getItem(KEY) ? "done" : "show"));

  useEffect(() => {
    if (phase !== "show") {
      return undefined;
    }
    sessionStorage.setItem(KEY, "1");
    const leave = setTimeout(() => setPhase("leaving"), 1750);
    const done = setTimeout(() => setPhase("done"), 2350);
    return () => {
      clearTimeout(leave);
      clearTimeout(done);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (phase === "done") return null;
  return (
    <div data-testid="splash-screen" className="ff-splash" data-leaving={phase === "leaving"} aria-hidden="true">
      <svg className="ff-splash-svg" viewBox="0 0 620 100" role="img">
        <defs>
          <linearGradient id="ff-splash-grad" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="55%" stopColor="#22d3ee" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <text x="50%" y="70" textAnchor="middle" className="ff-splash-text">FLEETFLOW</text>
      </svg>
      <span className="ff-splash-line" />
      <span className="ff-splash-tag">B2B Network NCC</span>
    </div>
  );
};
